import * as React from "react";
import { observer, inject } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";

import { HorseForSaleStore } from "src/stores/HorseForSaleStore";
import { HorseForSale } from "src/model/HorseForSale";
import { SimpleCustomer, ExtractFriendlyName } from "src/model/Customer";

import { successMessage, errorMessage } from "../common/Toast";
import { FormDialog } from "../common/FormDialog";

type UpdateHipNumbersRequest = {
    [field: string]: number;
};

export interface Props {
    horseForSaleStore?: HorseForSaleStore;
    showDialog: boolean;
    horsesForSale: Array<HorseForSale>;
    onClose: () => void;
    onComplete: () => void;
}

export interface State {
    selectedSwapHipNumbers: UpdateHipNumbersRequest | {};
    showSwapHip: boolean;
    wasValidated: boolean;
    swapErrorMessage: string;
}

@inject("horseForSaleStore")
@observer
export class SwapHipNumbersDialog extends React.Component<Props, State> {
    private form: HTMLFormElement | null;

    constructor(props: Props) {
        super(props);
        this.state = {
            showSwapHip: true,
            wasValidated: false,
            swapErrorMessage: "",
            selectedSwapHipNumbers: {}
        };
    }

    swapHipNumbers = async () => {
        try {
            await this.props.horseForSaleStore!.swapHipNumbers(this.state.selectedSwapHipNumbers);
            successMessage(`Hip #s have been successfully swapped.`);
            this.props.onClose();
            this.props.onComplete();
        } catch (error) {
            errorMessage(error);
        }
    };

    formValidation = () => {
        const hipNumbersArrays = Object.values(this.state.selectedSwapHipNumbers);
        const noDuplicateHipNumbersArray = new Set(hipNumbersArrays);

        const isNaN: any = hipNumbersArrays.some(h => h.toString() === "NaN");

        if (hipNumbersArrays.length !== this.props.horsesForSale.length || isNaN) {
            this.setState({ swapErrorMessage: "Not all Hip #s have been swapped." });
            return false;
        } else if (noDuplicateHipNumbersArray.size !== this.props.horsesForSale.length) {
            this.setState({ swapErrorMessage: "Not all Hip #s have been swapped." });
            return false;
        }

        return true;
    };

    submit = (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault();
        e.stopPropagation();
        if (this.formValidation()) {
            this.setState({ wasValidated: false });
            this.swapHipNumbers();
            this.clearObject();
        } else {
            this.setState({ wasValidated: true });
        }
    };

    clearObject = () => {
        const selectedSwapHipNumbers = new Object();
        this.setState({ selectedSwapHipNumbers, swapErrorMessage: "" });
    };

    render() {
        const consignor = this.consignor;
        return (
            <FormDialog
                title={`Swap Hip #s ${consignor ? "for " + ExtractFriendlyName(consignor) : ""}`}
                modalSize="modal-lg"
                show={this.props.showDialog}
                onClose={() => {
                    this.clearObject();
                    this.props.onClose();
                }}
            >
                <form
                    className={"px-2 needs-validation " + (this.state.wasValidated === true ? "was-validated" : "")}
                    noValidate={true}
                    onSubmit={this.submit}
                    ref={ref => (this.form = ref)}
                >
                    {this.state.swapErrorMessage !== "" && <div className="alert alert-danger text-center">{this.state.swapErrorMessage}</div>}
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Hip #</th>
                                <th>Horse Name</th>
                                <th>Updated Hip #</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.horsesForSale.map(hfs => {
                                return (
                                    <tr key={hfs.id}>
                                        <td>{hfs.hipNumber}</td>
                                        <td>{hfs.horse.name}</td>
                                        <td>
                                            <select
                                                className="form-control not-required"
                                                name="horseForSale.id"
                                                onChange={e => {
                                                    const selectedSwapHipNumbers = this.state.selectedSwapHipNumbers;
                                                    selectedSwapHipNumbers[hfs.id] = parseInt(e.target.value, 10);
                                                    this.setState({ selectedSwapHipNumbers });
                                                }}
                                                value={`${this.state.selectedSwapHipNumbers[hfs.id] || ""}`}
                                            >
                                                <option value=""> - empty - </option>
                                                {this.props.horsesForSale
                                                    .filter(
                                                        h =>
                                                            !Object.values(this.state.selectedSwapHipNumbers).some(
                                                                v => v === h.hipNumber && v !== this.state.selectedSwapHipNumbers[hfs.id]
                                                            )
                                                    )
                                                    .map((h, i) => {
                                                        return h.hipNumber ? (
                                                            <option key={i} value={h.hipNumber}>
                                                                {h.hipNumber}
                                                            </option>
                                                        ) : null;
                                                    })}
                                            </select>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <div className="form-row text-right">
                        <button
                            type="button"
                            className="btn btn-secondary mr-auto"
                            onClick={() => {
                                this.clearObject();
                                this.props.onClose();
                            }}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary">
                            Swap Hip #s
                        </button>
                    </div>
                </form>
            </FormDialog>
        );
    }

    private get consignor(): SimpleCustomer | null {
        return this.props.horsesForSale.length > 0 ? this.props.horsesForSale[0].consignor : null;
    }
}



// WEBPACK FOOTER //
// ./src/components/horses-for-sale/SwapHipNumbersDialog.tsx